import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCcMenuRowViewModel } from '../../state/cc-list-combined-selectors';

export interface CCRowMenuCellState extends AgCellState {}

@Injectable()
export class CCRowMenuCellLocalStoreService extends AgCellLocalStoreService<CCRowMenuCellState> {

  readonly viewModel$ = this.select({
    params: this.params$,
    menu: this.store.select(selectCcMenuRowViewModel),
  })

  constructor(private store: Store) {
    super({
      cellValue: '',
      params: null
    })
  }
}

